import React from 'react'

const ServicesListSection = (props) => {
    return (
        <React.Fragment>
            <section>
                <div className="container-zk">
                    <div className='my-md-5 my-3'>
                        <h2 className='fw-700 fs-zk-40 text-zk-primary text-raleway lh-1'>
                        {props.Title}
                        </h2>
                        <div className='fw-400 fs-zk-18 text-poppins mt-4'>
                        {props.Paragraph1}
                        </div>
                        <ul className='row py-3 fs-zk-18'>
                            {props.ListItems.map((item, index) => {
                                return (
                                    <>
                                        <li key={index} className='fw-400 fs-zk-16 text-poppins mt-2 col-md-4'>
                                            {item}  
                                        </li>
                                    </>
                                    // <li key={index} className='fw-400 fs-zk-16 text-poppins mt-2'>
                                    //     {item}
                                    // </li>
                                )
                            }
                            )}
                        </ul>
                        <div className='fw-400 fs-zk-18 text-poppins mt-2'>
                            {props.Paragraph2}
                        </div>
                    </div>
                </div>    
            </section>
        </React.Fragment>
    )
}

export default ServicesListSection
